// export const heredofamilialDiseases = [
//   {
//     label: "Hypertension",
//     value: "hypertension",
//     checked: false,
//   },
//   {
//     label: "Cancer",
//     value: "cancer",
//     checked: false,
//   },
//   {
//     label: "Asthma",
//     value: "asthma",
//     checked: false,
//   },
//   {
//     label: "Stroke",
//     value: "stroke",
//     checked: false,
//   },
//   {
//     label: "Diabetes",
//     value: "diabetes",
//     checked: false,
//   },
//   {
//     label: "Heart disease",
//     value: "heart_disease",
//     checked: false,
//   },
// ];
export const heredofamilialDiseases = [
  { label: "None", value: "None", checked: false },
  { label: "Allergy", value: "Allergy", checked: false },
  { label: "Asthma", value: "Asthma", checked: false },
  { label: "Cancer", value: "Cancer", checked: false },
  {
    label: "Cerebrovascular Disease",
    value: "Cerebrovascular Disease",
    checked: false,
  },
  {
    label: "Coronary Artery Disease",
    value: "Coronary Artery Disease",
    checked: false,
  },
  { label: "Diabetes Mellitus", value: "Diabetes Mellitus", checked: false },
  {
    label: "Epilepsy/Seizure Disorder",
    value: "Epilepsy/Seizure Disorder",
    checked: false,
  },
  {
    label: "Extrapulmonary Tuberculosis",
    value: "Extrapulmonary Tuberculosis",
    checked: false,
  },
  { label: "Pulmonary Tuberculosis", value: "Pulmonary Tuberculosis", checked: false },
  { label: "Hepatitis", value: "Hepatitis", checked: false },
  { label: "Hyperlipidemia", value: "Hyperlipidemia", checked: false },
  { label: "Hypertension", value: "Hypertension", checked: false },
  { label: "Peptic Ulcer", value: "Peptic Ulcer", checked: false },
  { label: "Pneumonia", value: "Pneumonia", checked: false },
  { label: "Thyroid Disease", value: "Thyroid Disease", checked: false },
  { label: "Tuberculosis", value: "Tuberculosis", checked: false },
  {
    label: "Urinary Tract Infection",
    value: "Urinary Tract Infection",
    checked: false,
  },
  { label: "Mental Illness", value: "Mental Illness", checked: false },
];
